import { CustomTextField } from "./CustomTextField";
import { DateTimePicker, DateTimePickerProps } from "@mui/x-date-pickers";
import { ChevronDownIcon } from "./Icons";

export const CustomDateTimePicker = (props: DateTimePickerProps<Date>) => {
  return (
    <DateTimePicker ampm={false} slots={{ textField: CustomTextField, openPickerIcon: ChevronDownIcon }} {...props} />
  );
};
